// Curated demo photography (premium hospitality / travel aesthetic)
const w = (u, width = 1000) => `${u}&w=${width}`;

export const DEMO = {
  cover: w("https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&q=85", 1200),
  gallery: [
    "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1644057501622-dfa7dd26dbfb?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1648634158203-199accfd7afc?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1781249144275-c04daed37031?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1649083048428-3d8ed23a3ce0?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1584346133934-a3afd2a33c4c?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1505577058444-a3dab90d4253?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1505873242700-f289a29e1e0f?crop=entropy&cs=srgb&fm=jpg&q=85",
  ].map((u) => w(u)),
  restaurant: w("https://images.unsplash.com/photo-1583354608715-177553a4035e?crop=entropy&cs=srgb&fm=jpg&q=85"),
  cafe: w("https://images.unsplash.com/photo-1707241358597-bafcc8a8e73d?crop=entropy&cs=srgb&fm=jpg&q=85"),
  duomo: w("https://images.unsplash.com/photo-1610016302534-6f67f1c968d8?crop=entropy&cs=srgb&fm=jpg&q=85"),
  bar: w("https://images.unsplash.com/photo-1702725365144-6e8584ea54e4?crop=entropy&cs=srgb&fm=jpg&q=85"),
  navigli: w("https://images.unsplash.com/photo-1505577058444-a3dab90d4253?crop=entropy&cs=srgb&fm=jpg&q=85"),
  kitchen: w("https://images.unsplash.com/photo-1781249144275-c04daed37031?crop=entropy&cs=srgb&fm=jpg&q=85"),
  emptyState: w("https://images.unsplash.com/photo-1720247520862-7e4b14176fa8?crop=entropy&cs=srgb&fm=jpg&q=85"),
};
